import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Alert } from 'antd';
import { WebsiteIndexEntry } from '../../../deepAnalysis/websiteIndexEntry/types';
import { useDeleteWebsiteIndexEntryMutation } from '../../../deepAnalysis/websiteIndexEntry/service';
import { useLazyFetchTrackedKeywordsCountQuery } from '../../../trackedKeywords/service';


type Props = {
    selectedWebsite: WebsiteIndexEntry;
};


export default function RemoveUrlTab({ selectedWebsite }: Props) {
    const navigate = useNavigate();

    const [deleteTrackedWebsite, { isLoading: isDeletingTrackedWebsite }] = useDeleteWebsiteIndexEntryMutation();
    const [fetchTrackedKeywordsCount, { isFetching: isFetchingTrackedKeywordsCount }] = useLazyFetchTrackedKeywordsCountQuery();

    const handleDeleteTrackedWebsite = async () => {
        try {
            await deleteTrackedWebsite({ guid: selectedWebsite.guid }).unwrap();
            await fetchTrackedKeywordsCount(undefined, false).unwrap();

            navigate('/dashboard');
        } catch (error) { }
    };

    // Add loading tracked keywords count to keep the button loading while the tracked websites refetch, both are invalidated
    const isRemoveButtonLoading = isDeletingTrackedWebsite || isFetchingTrackedKeywordsCount;

    return (
        <div className="remove-url-tab">
            <Alert
                message="Please note!"
                description={
                    <React.Fragment>
                        <div>By deleting this website you will not be able to:</div>
                        <ul>
                            <li>Receive weekly emails regarding this website's performance</li>
                            <li>Monitor the loading time of your website</li>
                            <li>Monitor the uptime of your website</li>
                            <li>Monitor the backlinks of your website</li>
                            <li>Check the top keywords of your website</li>
                        </ul>
                    </React.Fragment>
                }
                type="error"
                showIcon
            />

            <Button
                type="danger"
                onClick={handleDeleteTrackedWebsite}
                loading={isRemoveButtonLoading}
            >
                Remove {selectedWebsite.domain}
            </Button>
        </div>
    );
}
